
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48.82 47.33"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#515358"}},[_c('path',{attrs:{"d":"M39.61 38.99h9.21V0H9.83v7.72h29.78v31.27z"}}),_c('path',{attrs:{"d":"M9.83 8.34h29.16v30.65H9.83z"}}),_c('path',{attrs:{"d":"M9.21 39.61V8.34H0v38.99h38.99v-7.72H9.21z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/copy.svg